// 获取assets静态资源
  const getImage = (name: string | undefined): string => {
    return new URL(`../assets/images/header/${name}.svg`, import.meta.url)
      .href;
  };
  export default getImage